const cycleRoutes = (state = [], action) => {

	let cycleRoutes;

	switch (action.type) {

		case 'PUT_JOURNEYS':

			cycleRoutes = action.payload.journeys;

			return { ...cycleRoutes };

		case 'CLEAR_JOURNEYS':

			cycleRoutes = {};

			return { ...cycleRoutes };

		default:

			return state;
	}
}

export default cycleRoutes;



// WEBPACK FOOTER //
// ./src/reducers/cycleRoutes.js